import { render } from "./StructureElementDetailPage.vue?vue&type=template&id=073a7e1c&scoped=true"
import script from "./StructureElementDetailPage.vue?vue&type=script&lang=js"
export * from "./StructureElementDetailPage.vue?vue&type=script&lang=js"

import "./StructureElementDetailPage.vue?vue&type=style&index=0&id=073a7e1c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073a7e1c"]])

export default __exports__